import { produce } from 'immer'

import { GlobalType } from '../Global'
import { StripePrice, StripeState } from './StripeState'
import { StripeType } from './StripeType'

export const initialStripeState: StripeState = {
  priceId: [],
  price: []
}

export const stripeReducer = (state = initialStripeState, action: Action) =>
  produce(state, draft => {
    switch (action.type) {
      case GlobalType.CLEAR_LOADED_DATA: {
        return { ...initialStripeState }
      }
      case StripeType.SET_PRICE_ID: {
        draft.priceId = action.payload.priceId
        return
      }
      case StripeType.SET_PRICE: {
        draft.price = action.payload.price
        return
      }
      default: {
        return state
      }
    }
  })

type Action =
  | { type: GlobalType.CLEAR_LOADED_DATA }
  | { type: StripeType.SET_PRICE; payload: { price: Array<StripePrice> } }
  | { type: StripeType.SET_PRICE_ID; payload: { priceId: Array<string> } }
